/**
 * QSSearch 可见性监听补丁
 *
 * 解决 QSSearch 组件在 v-show 场景下布局计算不准确的问题
 * 通过 IntersectionObserver 监听组件可见性变化，自动重新计算布局
 *
 * 使用方法：
 * import qsSearchVisibilityPatch from '@/utils/qsSearchVisibilityPatch'
 * Vue.use(qsSearchVisibilityPatch)
 */

export default {
  install(Vue) {
    // 全局 mixin，只对 QSSearch 组件生效
    Vue.mixin({
      mounted() {
        // 只对 QSSearch 组件生效
        const isQSSearch = this.$options.name === 'QSSearch' ||
                          this.$options.componentName === 'QSSearch'

        if (!isQSSearch) {
          return
        }

        // 如果组件已经有 intersectionObserver，说明组件自己已经处理了，不需要 patch
        if (this.intersectionObserver) {
          return
        }

        // 监听组件可见性变化
        if (window.IntersectionObserver && this.calcLayout) {
          this._visibilityObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                // 组件变为可见时重新计算布局
                this.$nextTick(() => {
                  this.calcLayout()
                })
              }
            })
          }, {
            threshold: 0.01, // 至少 1% 可见时触发
          })

          this._visibilityObserver.observe(this.$el)
        }
      },

      beforeDestroy() {
        // 清理 observer
        if (this._visibilityObserver) {
          this._visibilityObserver.disconnect()
          this._visibilityObserver = null
        }
      },
    })
  },
}
